import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgAlertFilled = (props: SvgProps) => (
  <Svg fill="none" height={25} width={25} {...props}>
    <Path
      clipRule="evenodd"
      d="M12.63 23.668c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.924-11 11 4.925 11 11 11m1.066-8.062.281-9.876h-2.723l.28 9.876zm-2.132 2.083a1.3 1.3 0 0 0-.388.96q0 .562.388.95.397.387 1.066.387t1.056-.387q.398-.388.398-.95 0-.572-.398-.96-.387-.397-1.056-.397t-1.066.397"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgAlertFilled);
export default Memo;
